import * as React from 'react';

import type {Href, HrefHook, NavigationOptions} from 'src/types';

export const defaultSetHref = (
  _newHref: Href | ((oldHref: Href) => Href),
  _options?: NavigationOptions,
): void => undefined;

const defaultHrefContext: HrefHook = ['/', defaultSetHref];

export default React.createContext<HrefHook>(defaultHrefContext);
